export const ADD_EMPLOYEE = 'ADD_EMPLOYEE';
export const GET_EMPLOYEE_LIST = 'GET_EMPLOYEE_LIST';
export const GET_EMPLOYEE_BY_ID = 'GET_EMPLOYEE_BY_ID';
export const UPDATE_EMPLOYEE = 'UPDATE_EMPLOYEE';
export const DELETE_EMPLOYEE = 'DELETE_EMPLOYEE';
export const RESET_EMPLOYEE = 'RESET_EMPLOYEE';

// Employee Document
export const GET_EMPLOYEE_DOCS = 'GET_EMPLOYEE_DOCS';
export const GET_EMPLOYEE_DOCS_DETAILS = 'GET_EMPLOYEE_DOCS_DETAILS';

export const EMPLOYEE_SEARCH = 'EMPLOYEE_SEARCH';
export const EMPLOYEE_COUNTRY_LIST = 'EMPLOYEE_COUNTRY_LIST';
export const EMPLOYEE_BIRTH_PASSPORT_GRADUATION_COUNTRY_LIST =
  'EMPLOYEE_BIRTH_PASSPORT_GRADUATION_COUNTRY_LIST';

export const GETEMPLOYEES = 'GETEMPLOYEES';
export const GET_ALL_EMPLOYEE_REQUESTS = "GET_ALL_EMPLOYEE_REQUESTS";
export const GET_ALL_REQUEST_TYPES = "GET_ALL_REQUEST_TYPES";
export const SET_CURRENT_REQUEST = "SET_CURRENT_REQUEST";
export const GET_ALL_ACTIVE_EMPLOYEES = "GET_ALL_ACTIVE_EMPLOYEES";
export const GET_EMPLOYEE_TOTALS = "GET_EMPLOYEE_TOTALS";
export const GET_ALL_REQUESTS_OPTIONS = "GET_ALL_REQUESTS_OPTIONS"
export const GET_ALL_EMPLOYEE_VACATION = "GET_ALL_EMPLOYEE_VACATION"
export const GET_ALL_EMPLOYEE_VACATION_LIST = "GET_ALL_EMPLOYEE_VACATION_LIST"
export const GET_ALL_EMPLOYEE_VACATION_LIST_FOR_SET = "GET_ALL_EMPLOYEE_VACATION_LIST_FOR_SET"
export const SET_CURRENT_EMPLOYEE = "SET_CURRENT_EMPLOYEE"
export const GET_EMPLOYEES_WITH_LIBRARY_SUMMARY = "GET_EMPLOYEES_WITH_LIBRARY_SUMMARY";
export const GET_EMPLOYEE_CLASSES = "GET_EMPLOYEE_CLASSES";
export const GET_EMPLOYEE_LIBRARY_SUMMARY = "GET_EMPLOYEE_LIBRARY_SUMMARY";
export const GET_EMPLOYEE_BOOKS_SUMMARY = "GET_EMPLOYEE_BOOKS_SUMMARY";
export const GET_EMPLOYEE_STORY_SUMMARY = "GET_EMPLOYEE_STORY_SUMMARY";
export const GET_EMPLOYEE_BORROWED_BOOKS = "GET_EMPLOYEE_BORROWED_BOOKS";
export const GET_EMPLOYEE_NOT_RETURNED_BOOKS = "GET_EMPLOYEE_NOT_RETURNED_BOOKS";
export const GET_COMPREHENSIVE_REPORTS = "GET_COMPREHENSIVE_REPORTS";
export const GET_EMPLOYEE_APPLICATIONS = "GET_EMPLOYEE_APPLICATIONS";
export const GET_LOGIN_HISTORY = "GET_LOGIN_HISTORY";
export const GET_DB_HISTORY = "GET_DB_HISTORY";
export const ADD_EMPLOYEE_LOG = "ADD_EMPLOYEE_LOG";
export const GET_DEPARTMENT_REPORT = "GET_DEPARTMENT_REPORT";

